import 'babel-polyfill';
import React from 'react';
import { render } from 'react-dom';
import UserStore from './state/user.js';
import LectureStore from './state/lecture.js';
import CourseStore from './state/course.js';
import EnrollmentStore from './state/enrollment.js';
import App from './app/App/App.jsx';
import { AppContainer } from 'react-hot-loader';

type Props = {
  store: any
}

const stores = {
  userStore: new UserStore(),
  courseStore: new CourseStore(),
  lectureStore: new LectureStore(),
  enrollmentStore: new EnrollmentStore()
};

render(<AppContainer><App stores={ stores } /></AppContainer>, document.getElementById('root'));

if(module.hot) {
  module.hot.accept('./app/App/App.jsx', () => {
    const ReloadedApp = require('./app/App/App.jsx').default;
    render(<AppContainer><ReloadedApp stores={ stores } /></AppContainer>, document.getElementById('root'));
  });
}


/** WEBPACK FOOTER **
 ** ./src/js/index.js
 **/